const allowedFilesTypes = {
    images: 'JPG, JPEG e PNG',
    imagesAndPdf: 'JPG, JPEG, PNG e PDF'
}

export default allowedFilesTypes;